import { getFetcher, postFetcher } from "./fetchers";
import { ParticipantExam, ParticipantFileStatusCode } from "../types/components";

export const getTranslations = async (lng: string, ns: string) =>
  getFetcher(`/superadmin/public/translation-language/${lng}/json?context=${ns}`);

export const requestPasswordReset = (email: string) =>
  postFetcher("/auth/req-password-reset", { arg: { email } });

export const updatePassword = ({
  email,
  password,
  password_confirmation,
  passwordToken,
}: {
  email: string;
  password: string;
  password_confirmation: string;
  passwordToken: string;
}) =>
  postFetcher("/auth/update-password", {
    arg: {
      email,
      password,
      password_confirmation,
      passwordToken,
    },
  });

export const getFileStatus = (statusCode: ParticipantFileStatusCode) =>
  getFetcher(`/common/participant-file-status?filter[eq:code]=${statusCode}`);

export const getTrainingDocumentStatus = (statusCode: string) =>
  getFetcher(`/common/training-document-status?filter[eq:code]=${statusCode}`);

export const getTrainingDocumentType = (code: string) =>
  getFetcher(`/common/training-document-type?filter[eq:code]=${code}`);

export const downloadFile = (id: string): Promise<Blob> =>
  getFetcher(`/file/download/${id}`, false, { responseType: "blob" });

export const getExam = async (id: string): Promise<ParticipantExam> =>
  getFetcher(`/common/participant-exam/${id}`);

export const getExamByFilter = async (id: string | undefined): Promise<ParticipantExam[]> =>
  getFetcher(
    `/common/participant-exam?include=exam&filter[eq:exam_id]=${id}&per_page=1&sort=-created_at`,
  );

export const getGdprFile = async (userId?: string) =>
  getFetcher(
    `/common/legal-file?include=file&filter[eq:user_id]=${userId}&filter[eq:type.code]=gdpr&sort=-created_at&per_page=1`,
  );

export const getAgreementFile = async (userId?: string) =>
  getFetcher(
    `/common/legal-file?include=file&filter[eq:user_id]=${userId}&filter[eq:type.code]=agreement_generation_and_acceptance&sort=-created_at&per_page=1`,
  );
